import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import useHttp from "./hooks/useHttp";
import { PAYPAL_PAYMENT_URL } from "./utils/api-ends";
import LoaderImg from "./assets/media/loader.gif";

function PaypalWeb () {
  const { isLoading: loadingPaypalForm, sendRequests: fetchPaypalForm } =
    useHttp();
  const [paypalForm, setPaypalForm] = useState("");
  const { paymentRequestId, authToken } = useParams();

  useEffect(() => {
    const response = (data) => {
      setPaypalForm(data?.html_form);
    };
    fetchPaypalForm(
      {
        url: PAYPAL_PAYMENT_URL,
        method: "post",
        headers: {
          authorization: `Bearer ${authToken}`,
        },
        data: {
          payment_request_id: paymentRequestId,
        },
      },
      response
    );
  }, []);

  return (
    <>
      {loadingPaypalForm ? (
        <div className="d-flex justify-content-center">
          <img style={{ width: "40px" }} src={LoaderImg} alt="" />
        </div>
      ) : paypalForm?.length > 0 ? (
        <div
          style={{
            display: "flex",
            marginTop: "50px",
            justifyContent: "center",
            alignItems: "center",
          }}
          dangerouslySetInnerHTML={{ __html: paypalForm }}
        />
      ) : (
        "Something went wrong !"
      )}
    </>
  );
}
export default PaypalWeb;
